<template>
    <!--fixed header-->
    <div class="fixed xl:hidden lg:hidden md:hidden w-full surface-0 px-3 shadow-2 z-4 top-0 min-h-3">
        <div class="flex w-full flex-column">
            <div class="flex flex-row w-full mt-2 mb-2">
                <span class="flex flex-1 text-900 font-medium mr-3 text-2xl ">
                    {{ header[lang_].title }}
                </span>
                <span v-if="deal && deal.id" class="flex">
                    <div @click="copy(deal.id)" class="ml-2 py-1 px-2 flex text-xs border-round-md font-semibold border-2 surface-border cursor-pointer text-500 font-medium align-items-center" >
                        <span class="flex">{{get_short_id(deal.id)}}</span>
                        <span class="flex pi pi-copy ml-2 text-500 text-xs cursor-pointer"></span>
                    </div>
                </span>
            </div>
            <div v-if="deal && deal.date_created" class="flex w-full mb-2 text-sm text-500">
                {{ content[lang_].pay_until }}: <span class="ml-2">{{ formatDate(deal.date_created) }}</span>
            </div>
        </div>
    </div>

    <div class="center w-full h-full pl-0 pr-0 xl:pl-4 xl:pr-4 lg:pl-3 lg:pr-3">
		<div class="flex w-full h-full justify-content-center pt-0 pb-0 xl:pt-4 xl:pb-4 lg:pt-3 lg:pb-4 align-items-start">
			<div class="flex flex-column w-full h-full surface-0 pt-4 pl-3 pr-3 xl:p-6 lg:p-5 md:p-4 xl:border-round-xl lg:border-round-xl">
                <div class="w-full h-fullflex-column">
                    <div class="w-full mb-3 hidden xl:flex lg:flex md:flex">
                        <span class="flex text-900 font-medium mr-3 text-3xl xl:text-6xl lg:text-5xl md:text-4xl">
                            {{ header[lang_].title }}
                        </span>
                    </div>

                    <div v-if="deal" class="flex-column w-full max-w-30rem mb-5">
                        <span v-if="deal && deal.seller_fullname" class="flex flex-column mb-3">
                            <span class="flex text-500 text-sm mb-2">{{ content[lang_].recipient }}:</span>
                            <span class="flex text-800 font-medium text-lg">{{ deal.seller_fullname }}</span>
                        </span>
                        <span v-if="deal && deal.seller_amount && deal.seller_currency_code" class="flex flex-column mb-3">
                            <span class="flex text-500 text-sm mb-2">{{ content[lang_].amount }}:</span>
                            <span class="flex text-800 font-medium text-3xl">{{ get_format_amount(deal.seller_amount.$numberDecimal, deal.seller_currency_code) }}</span>
                        </span>
                        <span v-if="deal && deal.seller_description" class="flex flex-column mb-3">
                            <span class="flex text-500 text-sm mb-2">{{ content[lang_].description }}:</span>
                            <span class="flex text-800 font-medium text-sm">{{ deal.seller_description }}</span>
                        </span>
                    </div>

                    <div v-if="isAuth && !totalError" class="w-full max-w-30rem">

                        <!--AMOUNT TO RECEIVE-->
                        <span class="text-color-secondary">{{ lang('currency_receive') }}: </span>
                        <div class="p-inputgroup w-full mt-2 mb-3 cur_drop" v-if="deal && loaded">
                            <InputNumber placeholder="Сумма счета" v-model="deal.seller_amount.$numberDecimal" inputId="locale-us"
                                class="p-inputtext-lg border-2 border-round-lg surface-border amount_input"
                                :min-fraction-digits="0" :max-fraction-digits="2" disabled/>

                            <span class="p-inputgroup-addon p-0 border-2 surface-border surface-0">
                                <Dropdown id='currency' v-model="currency_receive" :options="currencies_receive" disabled
                                    option-label="name" class='border-none border-round-right-lg w-9rem p-inputtext-lg'
                                    :placeholder="lang('currency_receive')">
                                    <template #value="slotProps">
                                        <div v-if="slotProps.value" class="flex align-items-center w-7rem">
                                            <img :src="`/images/svg/countries/${slotProps.value.flag}.svg`" :alt="slotProps.value.label" class="mr-2 w-3 border-200 border-1 border-circle" />
                                            <div>{{ slotProps.value.code.toUpperCase() }}</div>
                                        </div>
                                        <span v-else>
                                            {{ slotProps.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="slotProps">
                                        <div class="flex align-items-center w-7rem">
                                            <img :src="`/images/svg/countries/${slotProps.option.flag}.svg`" :alt="slotProps.option.label" class="mr-2 w-3 border-200 border-1 border-circle" />
                                            <div>{{ slotProps.option.code.toUpperCase() }}</div>
                                        </div>
                                    </template>
                                </Dropdown>

                            </span>
                        </div>
                        <Skeleton v-else height="3rem" class="mt-2 mb-3"/>
                    
                        <!--AMOUNT TO SEND-->
                        <span class="text-color-secondary">{{ lang('currency_send') }}: </span>
                        <div class="p-inputgroup w-full mt-2 mb-3 cur_drop" v-if="amount_send && loaded">
                            <InputNumber placeholder="Сумма счета" v-model="amount_send" inputId="locale-us"
                                class="p-inputtext-lg border-2 border-round-lg surface-border amount_input"
                                :min-fraction-digits="0" :max-fraction-digits="2" disabled />

                            <span class="p-inputgroup-addon p-0 border-2 surface-border surface-0">
                                <Dropdown id='currency' v-model="currency_send" :options="currencies_send"
                                    option-label="name" class='border-none border-round-right-lg w-9rem p-inputtext-lg'
                                    :placeholder="lang('currency_send')">
                                    <template #value="slotProps">
                                        <div v-if="slotProps.value" class="flex align-items-center w-7rem">
                                            <img :src="`/images/svg/countries/${slotProps.value.flag}.svg`" :alt="slotProps.value.label" class="mr-2 w-3 border-200 border-1 border-circle" />
                                            <div>{{ slotProps.value.code.toUpperCase() }}</div>
                                        </div>
                                        <span v-else>
                                            {{ slotProps.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="slotProps">
                                        <div class="flex align-items-center w-7rem">
                                            <img :src="`/images/svg/countries/${slotProps.option.flag}.svg`" :alt="slotProps.option.label" class="mr-2 w-3 border-200 border-1 border-circle" />
                                            <div>{{ slotProps.option.code.toUpperCase() }}</div>
                                        </div>
                                    </template>
                                </Dropdown>

                            </span>
                        </div>
                        <Skeleton v-else height="3rem" class="mt-2 mb-3"/>

                        <div v-if="user_name" class="flex flex-row mb-3">
                            <span class="flex text-500">{{ lang('sender') }}: &nbsp</span>
                            <span class="flex text-500 cursor-pointer" @click="go_profile()"> 
                                {{ user_name }} &nbsp
                            </span>
                            <span class="pi pi-pencil text-500 cursor-pointer" @click="go_profile()"></span>
                        </div>

                        <!--PAY SYSTEM | BANKS-->
                        <span class="text-color-secondary">{{ lang('sender_bank') }}:</span>
                        <div v-if="loaded && payment_system" @click="payment_popup_show()"
                            class="input_pays flex flex-row cursor-pointer relative w-full mt-2 mb-3 px-2 mb-3 surface-border border-2 border-round-lg justify-content-left align-items-center">
                            <div class="flex w-1">
                                <img :src="payment_system.image" class="w-full pr-2">
                            </div>
                            <span class="flex flex-column">
                                <span class="flex text-700 text-md xl:text-lg white-space-nowrap">{{ payment_system.name[lang_] }}</span>
                                <span class="flex text-500 text-sm xl:text-md white-space-nowrap">
                                    {{ (payment_system.bank_code=='other_ru' || payment_system.bank_code=='other_id') ? lang('may_comissions') : payment_system.description[lang_] }}
                                </span>
                            </span>
                            <i class="pi pi-chevron-down text-600 absolute right-0 mr-1 surface-0 p-2 border-circle"></i>
                        </div>
                        <Skeleton v-else height="3rem" class="mt-2 mb-3"/>

                        <Dialog v-model:visible="payment_popup" modal :header="lang('sender_bank_choose')" 
                            class="w-full ml-2 mr-2 border-round-xl overflow-hidden" style="max-width: 500px;">
                            <div v-if="payment_systems_list" v-for="item of payment_systems_list">
                                <div class="flex flex-row cursor-pointer relative px-2 mb-3 surface-border border-2 border-round-lg justify-content-left align-items-center input_banks"    
                                @click="choose_payment(item.code)">
                                    <div class="flex w-1">
                                        <img :src="item.image" class="w-full pr-2">
                                    </div>
                                    <span class="flex flex-column">
                                        <span class="flex text-700 text-sm xl:text-lg white-space-nowrap">{{ item.name[lang_] }}</span>
                                        <span class="flex text-500 text-xs xl:text-md white-space-nowrap">
                                            {{ (item.bank_code=='other_ru' || item.bank_code=='other_id') ? lang('may_comissions') : item.description[lang_] }}
                                        </span>
                                    </span>
                                    <div class="absolute right-0 mr-0 surface-0 p-2 border-circle">
                                        <div class="surface-border border-1 border-circle" >
                                            <div class="border-circle" style="width:18px;height:18px;margin:3px"
                                            :class="{'bg-green-400': payment_system.code == item.code, 'surface-0': payment_system.code != item.code}"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Dialog>

                        <!--DESCRIPTION-->
                        <div v-if="!show_description" class="w-full mb-3">
                            <span class="cursor-pointer text-primary" @click="add_description()">
                                <span class="mr-2">{{ lang('add_comment') }}</span>
                                <i class="pi pi-pencil text-600 mr-2 text-primary"></i>
                            </span>
                        </div>
                        <div v-else class="mb-3">
                            <span class="text-color-secondary">{{lang('description')}}:</span>
                            <Textarea  rows="5" cols="20" class="w-full surface-border border-2 border-round-lg text-sm p-2 mt-2 mb-1" 
                                :value="description" :placeholder="lang('description_placeholder')"
                                @input="description = $event.target.value"
                                style="resize: none !important; font-family: inherit;"
                                />
                            
                            <span class="cursor-pointer text-primary" @click="add_description()">
                                <span class="mr-2">{{ lang('hide_comment') }}</span>
                                <i class="pi pi-replay text-600 mr-2 text-primary"></i>
                            </span>
                        </div>

                        <!--BUTTON-->
                        <div class="field w-full">
                            <Button @click="create()" :label="lang('btn_pay')" class="p-button-lg w-full border-round-lg" :disabled="!check_custom_valid" :loading="isLoading" />
                        </div>

                    </div>

                    <div v-if="totalError" class="w-full max-w-30rem">
                        <InlineMessage severity="warn" class="border-round-xl">{{ totalErrorMessage }}</InlineMessage>
                    </div>

                    <div v-if="!isAuth" class="w-full max-w-30rem my-3 border-round-2xl overflow-hidden">
                        <span class="block text-500 text-lg mb-3 text-center p-3">
                            {{ content[lang_].reg_auth }}
                        </span>

                        <div class="text-center align-items-center">
                            <AuthTgButton :redirect="null" :reload="true"/>
                        </div>
                        
                        <Divider align="center" type="dotted" class="p-3">
                            <span class="text-500">{{ content[lang_].or }}</span>
                        </Divider>

                        <TabView>
                            <TabPanel header="">
                                <template #header>
                                    <span class="text-sm font-medium">{{ content[lang_].auth }}</span>
                                </template>
                                <AuthForm />
                            </TabPanel>
                            <TabPanel header="">
                                <template #header>
                                    <span class="text-sm font-medium">{{ content[lang_].reg }}</span>
                                </template>
                                <RegForm />
                            </TabPanel>
                        </TabView>
                    </div>

                </div>
			</div>
		</div>
	</div>
</template>



<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import BigNumber from 'bignumber.js'
import { useRoute } from 'vue-router'
import RegForm from '@/components/public/registration/RegForm.vue' 
import AuthForm from '@/components/public/auth/AuthForm.vue' 
import AuthTgButton from '@/components/widgets/AuthTgButton.vue' 

export default {
    name: 'Deal',
    data() {
        return {
            header:{
                ru: {
                    title: 'Сделка'
                },
                en: {
                    title: 'Deal'
                },
            },
            content: {
                ru: {
                    pay_until: 'Оплатить до',
                    recipient: 'Получатель',
                    amount: 'Сумма сделки',
                    description: 'Описание',
                    reg_auth: 'Для оплаты сделки авторизуйтесь или зарегистрируйтесь',
                    copied: 'Скопировано',
                    or: 'или',
                    reg: 'Регистрация',
                    auth: 'Авторизация',
                },
                en: {
                    pay_until: 'Pay until',
                    recipient: 'Recipient',
                    amount: 'Amount',
                    description: 'Description',
                    reg_auth: 'To pay the deal, log in or register',
                    copied: 'Copied',
                    or: 'or',
                    reg: 'Registration',
                    auth: 'Authorization',
                },
            },
            errors: {
                ru: {
                    no_required_data: 'Не хватает данных для проведения платежа',
                    no_rates: 'В данный момент нет возможности принять этот платеж',
                    no_current_bank: 'Нет доступных мерчантов для выплаты на этот банк',
                    no_currency_send: 'Валюта отправки не определена',
                    no_payment_system: 'Нет подходящей платежной системы',
                    no_payment_systems_loaded: 'Не загружены платежные системы',
                    no_rates_loaded: 'Не загружены курсы валют',
                    no_currencies_loaded: 'Не загружены валюты',
                    no_banks_loaded: 'Не загружены банки'
                },
                en: {
                    no_required_data: 'There is not enough information to make a payment',
                    no_rates: 'There is no way to accept this payment at the moment.',
                    no_current_bank: 'There are no available merchants for payment to this bank',
                    no_currency_send: 'Sending currency is not defined',
                    no_payment_system: 'No suitable payment system',
                    no_payment_systems_loaded: 'Payment systems are not loaded',
                    no_rates_loaded: 'Currency rates not loaded',
                    no_currencies_loaded: 'No currencies loaded',
                    no_banks_loaded: 'Banks not loaded'
                }
            },

            deal: null, // загружаем по хешу
            
            // данные отправителя
            amount_send: null,
            rate: null,
            fullname: null,
            phone_number: null,
            card_number: null,
            account_number: null,
            description: null,
            show_description: false,

            rates: [],

            // платежные системы
            payment_systems_all: [],
            payment_system: null,
            payment_systems_list: [],

            // валюты для отправки и получения
            all_currencies: [],
            currency_send: null,
            currencies_send: [],
            currency_receive: null,
            currencies_receive: [],
            currency_send_code: null, // код валюты отправки
            currency_recipient_code: null, // код валюты счета

            // банки
            banks_obj: {},
            banks_list: [],
            bank_choosen: null,
            bank_popup: false,

            // получатели
            recipients: [],
            recipients_obj: {},
            recipient_choosen: null,

            payment_popup: false,
            recalculating: false,
            loaded: false,
            isLoading: false,
            check_custom_valid: true,

            // общая ошибка
            totalError: false,
            totalErrorMessage: null,
        }
    },
    watch: {
        // выбор платежной системы и валюты отправки при загрузке страницы срабатывает дважды, итого 3 раза
        // смена платежной системы
        payment_system: function (that) {
            if(!this.loaded || this.recalculating==true) return // не работает
            if (this.choose_payment_system(that.code)) this.payment_system = this.choose_payment_system(that.code)
            this.recalculate(false, false, 'payment_system_code')
		},
        // смена валюты отправки
        currency_send: function (that) {
            if(!this.loaded || this.recalculating==true) return // не работает
            this.recalculate(true, true, 'currency_send', that.code)
		},
    },
    computed: {
        isAuth() { return this.$store.getters.isAuthenticated },
        lang_() {return (this.$i18n.locale) ? this.$i18n.locale : 'ru'},
        user_name: function () { return this.$store.getters.StateUserName },
    },
    methods: {
        lang(value){
            return this.$t(`views.personal.billPage.${value}`)
        },
        copy(text){
            this.helper.copy_clipboard(text)
            this.$toast.add({ severity: 'info', summary: this.content[this.lang_].copied, detail: text, life: 1000 })
        },
        add_description(){
            if(this.show_description) this.show_description = false
            else this.show_description = true
            this.description = null
        },
        choose_payment(code){
            this.payment_system = this.choose_payment_system(code)
            this.payment_popup = false
        },
        get_format_amount(value, currency) {
            return this.helper.format_amount(value, currency)
        },
        // выбор платежной системы из списка
        choose_payment_system(code) {
            if(!this.payment_systems_list) return null
			for (const [k, v] of Object.entries(this.payment_systems_list)) {
				if (v.code == code) {
                    this.payment_popup = false
                    return v
                }
			}
            this.payment_popup = false
			return null
		},
        payment_popup_show(){
            this.payment_popup = true
        },
        to_percent(that) {
			const b_that = new BigNumber(that)
			const result = b_that.multipliedBy(100).toString()
			return result
		},
        get_code(val){
            return val.code
        },
        get_short_id(id){
            return this.helper.get_short_id(id)
        },
        formatDate(value) {
            return this.helper.format_date_short(value)
        },
        banks_popup_show(){
            this.bank_popup = true
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        choose_bank(code){
            this.bank_choosen = this.banks_list.find(item => item.code == code)
            this.bank_popup = false
        },
        get_bank_title(val){
            return this.helper.get_bank_title(val)
        },
        // форматирование списка платежных систем
        formatPaymentSystems(array){
            return this.helper.formatPaymentSystems(array)
        },
        // форматирование списка банков
        formatBankList(array){
            return this.helper.formatBankList(array)
        },
        // отправка на регистрацию
        go_reg() {
            // TODO: добавить обратный редирект
			this.$router.push({path: '/reg/'})
		},
        // отправка на авторизацию
        go_auth() { this.$router.push({path: '/auth/'}) },
        // отправка на профиль
        go_profile() { this.$router.push({path: '/personal/profile/'}) },

        // пересчет формы
        recalculate(
            relaunch_currency = false, 
            relaunch_payment_system = false,
            from = '',
            cur_send_code=null) {
            
            // обязательные данные
            if(!this.currency_recipient_code ||
                !this.recipient_bank_code ||
                !this.payment_systems_all ||
                !this.all_currencies ||
                !this.rates) {

                this.totalError = true
                this.totalErrorMessage = this.errors[this.lang_].no_required_data
                return
            }
  
            this.recalculating = true
            
            if(relaunch_currency){
                // определяем валюту для получения (по коду из счета)
                this.currency_receive = this.all_currencies[this.currency_recipient_code]
                this.currencies_receive = [this.currency_receive]

                // определяем валюты доступные для отправки
                let currencies_obj = {}
                for (const [k, v] of Object.entries(this.all_currencies)) {
                    for(let i = 0; i < this.rates.length; i++){
                        if((this.rates[i].from == v.code) && (this.rates[i].to == this.currency_receive.code)){
                            currencies_obj[v.code] = v
                        }
                    }
                }
                this.currencies_send = Object.values(currencies_obj)
                if(this.currencies_send.length <= 0) {
                    this.totalError = true
                    this.totalErrorMessage = this.errors[this.lang_].no_rates
                    return
                }

                // если валюта отправки определена
                if(from == 'currency_send'){
                    this.currency_send = this.currencies_send.find(item => item.code == cur_send_code)
                    this.currency_send_code = cur_send_code
                } else {
                    // если валюта отправки не определена - берем первую
                    this.currency_send = this.currencies_send[0]
                    this.currency_send_code = this.currency_send.code
                }
            } 
            
            // ищем текущий курс и устанавливаем лимиты
            let rate = 1
            let rate_obj = {}
            let payment_system_codes = []
            let bank_merchant_codes = []
            let bank_recipient_codes = []

            // если валюта отправки не определена
            if(!this.currency_send_code) {
                this.totalError = true
                this.totalErrorMessage = this.errors[this.lang_].no_currency_send
                return
            }

            rate_obj = this.rates.find(item => item.from == this.currency_send_code && item.to == this.currency_recipient_code)
            // если курс не найден
            if(!rate_obj) {
                this.totalError = true
                this.totalErrorMessage = this.errors[this.lang_].no_rates
                return
            }
            rate = rate_obj.rate
            this.rate = new BigNumber(rate).toNumber()
            payment_system_codes = rate_obj.payment_system_codes
            bank_merchant_codes = rate_obj.bank_merchant_codes
            bank_recipient_codes = rate_obj.bank_recipient_codes

            // ищем - есть ли в банках выплаты наш код банка
            if(!bank_recipient_codes.includes(this.recipient_bank_code)) {
                this.totalError = true
                this.totalErrorMessage = `${this.errors[this.lang_].no_current_bank} (${this.get_bank_title(this.recipient_bank_code)})`
                return false
            }

            
            // определяем платежные системы (обновляем если перевыбрана валюта отправки)
            if(relaunch_payment_system){
                this.payment_systems_list = []

                // если нет платежных систем
                if(payment_system_codes.length <= 0) {
                    this.totalError = true
                    this.totalErrorMessage = this.errors[this.lang_].no_payment_system
                    return
                }

                for(let i = 0; i < this.payment_systems_all.length; i++){
                    if(payment_system_codes.includes(this.payment_systems_all[i].code)){
                        // для merchant в платежные системы добавляем банки
                        if((this.payment_systems_all[i].code=='card' || this.payment_systems_all[i].code=='stock') && bank_merchant_codes.length > 0) {
                            for(let j = 0; j < bank_merchant_codes.length; j++){
                                let pay_sys = {
                                    code: bank_merchant_codes[j],
                                    type: this.payment_systems_all[i].type,
                                    bank_code: bank_merchant_codes[j],
                                    name: {
                                        ru: this.payment_systems_all[i].name['ru'] + ' ' + this.banks_obj[bank_merchant_codes[j]].name['ru'],
                                        en: this.payment_systems_all[i].name['en'] + ' ' + this.banks_obj[bank_merchant_codes[j]].name['en'],
                                    },
                                    description: {
                                        ru: this.payment_systems_all[i].description['ru'],
                                        en: this.payment_systems_all[i].description['en'],
                                    },
                                    comission: this.payment_systems_all[i].comission,
                                    sort: 1,
                                    image: this.banks_obj[bank_merchant_codes[j]].image,
                                }
                                this.payment_systems_list.push(pay_sys)
                            }
                        } else{
                            let pay_sys = {
                                code: this.payment_systems_all[i].code,
                                type: this.payment_systems_all[i].type,
                                bank_code: null,
                                name: this.payment_systems_all[i].name,
                                description: this.payment_systems_all[i].description,
                                comission: this.payment_systems_all[i].comission,
                                sort: 1,
                                image: this.payment_systems_all[i].image,
                            }
                            this.payment_systems_list.push(pay_sys)
                        }
                    }
                }
                this.payment_system = this.payment_systems_list[0]
            }

            this.amount_send = this.calc_amount_send(this.amount_receive, rate, this.payment_system.comission, this.comission_service)
            this.recalculating = false
		},

        // расчет суммы к отправке
        calc_amount_send(amount_receive, rate, comission_pay, comission_service){
            const b_rate = new BigNumber(rate)
            const b_amount_receive = new BigNumber(amount_receive)
            const b_comission_pay = new BigNumber(comission_pay)
            const b_comission_service = new BigNumber(comission_service)
            const b_rate_cs = b_rate.multipliedBy(b_comission_service)
            const b_rate_cp = b_rate.multipliedBy(b_comission_pay)
            const b_sender_amount = b_amount_receive.dividedBy(b_rate.minus(b_rate_cs).minus(b_rate_cp))
            return new BigNumber(b_sender_amount).toNumber()
        },

        // создание перевода по счету
        async create(){
            this.isLoading = true
            const data = {
                hash: this.hash,
                currency_code: this.currency_send_code,
                amount: this.amount_send,
                bank_code: this.get_code(this.payment_system),
                fullname: this.user_name,
                rate: this.rate,
                description: this.description,
            }

            await this.connect.deal_to_pay(data).then(res=>{
                console.log(res)
                if(res.result) {
                    this.$router.push({path: '/personal/transfer/'+res.data._id})
                } else {
                    for (let i = 0; i < res.errors.length; i++) {
                        this.showMess('error', 'Error', res.errors[i])
                    }
                }
                this.isLoading = false
                this.submitted = false
            })
            
        }
    },
    components: {
        RegForm,
        AuthForm,
        AuthTgButton
    },
    async mounted() {},

    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()

        if(route.params.hash && route.params.hash.length>=64) this.hash = route.params.hash

        if(!this.hash) this.$router.push({ name: 'Not found' })

        // получаем сделку
        const deal = await this.connect.get_deal(this.hash).then(res => res)
        if(!deal.result || !deal.data) this.$router.push({ name: 'Not found' })
        this.deal = deal.data
    console.log(this.deal)
        this.currency_recipient_code = (this.deal.seller_currency_code) ? this.deal.seller_currency_code : null
        this.recipient_bank_code = (this.deal.seller_bank_code) ? this.deal.seller_bank_code : null
        this.amount_receive = (this.deal.seller_amount) ? this.deal.seller_amount.$numberDecimal : null

        // если не авторизован
        if(!this.isAuth) {
            return
        }

        // запрашиваем платежные системы | обязательно
        const payment = await this.$store.dispatch('GetPaymentSystems').then(res => res)
        if (!payment.result || !payment.data || payment.data.payment_systems.length <= 0){ 
            this.totalError = true
            if(payment.errors && payment.errors.length > 0) this.totalErrorMessage = payment.errors[0]
            else this.totalErrorMessage = this.errors[this.lang_].no_payment_systems_loaded
            return
        }
        this.comission_service = payment.data.fee
        this.payment_systems_all = this.formatPaymentSystems(payment.data.payment_systems)

        //курсы доступных валют | обязательно
        const rates = await this.connect.currency_get_rates().then(res => res)
        if (!rates.result || !rates.data || rates.data.length <= 0){
            this.totalError = true
            if(rates.errors && rates.errors.length > 0) this.totalErrorMessage = rates.errors[0]
            else this.totalErrorMessage = this.errors[this.lang_].no_rates_loaded
            return
        }

        // фильтруем курсы на наличие банка получателя
        this.rates = rates.data.filter(item => item.bank_recipient_codes.includes(this.recipient_bank_code))

        // все валюты | обязательно
        const currencies = await this.connect.currency_get_all().then(res => res)
        if (!currencies.result || !currencies.data || currencies.data.length <= 0) {
            this.totalError = true
            if(currencies.errors && currencies.errors.length > 0) this.totalErrorMessage = currencies.errors[0]
            else this.totalErrorMessage = this.errors[this.lang_].no_currencies_loaded
            return
        }
        this.all_currencies = currencies.data

        // банки | обязательно
        const banks = await this.connect.bank_list('object').then(res => res)
        if (!banks.result || !banks.data || banks.data.length <= 0) {
            this.totalError = true
            if(banks.errors && banks.errors.length > 0) this.totalErrorMessage = banks.errors[0]
            else this.totalErrorMessage = this.errors[this.lang_].no_banks_loaded
            return
        }
        this.banks_obj = this.formatBankList(banks.data)

        // список прошлых получателей | НЕ обязательно
        const recipients = await this.connect.user_recipients('array').then(res => res)
        if (recipients.result && recipients.data && recipients.data.length > 0) {
            this.recipients = recipients.data
            this.recipient_choosen = this.recipients[0]
            this.recipients_obj = {}
            for(let i = 0; i < this.recipients.length; i++){
                this.recipients_obj[this.recipients[i]._id] = this.recipients[i]
            }
        }

        this.recalculate(true, true, 'start')
        this.loaded = true
    },
}
</script>